import { render, staticRenderFns } from "./conferencebooking.vue?vue&type=template&id=ba08bef6&"
import script from "./conferencebooking.vue?vue&type=script&lang=js&"
export * from "./conferencebooking.vue?vue&type=script&lang=js&"
import style0 from "./conferencebooking.vue?vue&type=style&index=0&style=true&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "conferencebooking.vue"
export default component.exports